<template>
    <b-card>
        <b-row>
            <b-col l="8">
                <h4>{{title}}</h4>  
            </b-col>
            <b-col l="4">
                <b-button class="float-right" variant="secondary"  @click="cancel()"><i class="fa fa-arrow-left mr-2" aria-hidden="true"></i>Back</b-button>        
            </b-col>
        </b-row>
        <b-card-body>
            <b-form @submit.stop.prevent="onSubmit">
                <b-form-group
                    id="name-group"
                    label="Name*"
                    label-for="input-name"
                    label-cols="2"
                >
                    <b-form-input
                        type="text"
                        id="input-name"
                        v-model="model.name"
                        required
                        placeholder="Enter Name"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="description-group"
                    label="Description"
                    label-for="input-description"
                    label-cols="2"
                >
                    <b-form-input
                        type="text"
                        id="input-description"
                        v-model="model.description"
                        placeholder="Enter Description"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="tax_rate-group"
                    label="Tax Rate"
                    label-for="input-tax_rate"
                    label-cols="2"
                >
                    <b-form-input
                        type="number"
                        step="any"
                        id="input-tax_rate"
                        v-model="model.tax_rate"
                        placeholder="Enter Tax Rate"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="uom-group"
                    label="UOM"
                    label-for="input-uom"
                    label-cols="2"
                >
                    <b-form-input
                        type="text"
                        id="input-uom"
                        v-model="model.uom"
                        placeholder="Unit of Measure"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="size_uom-group"
                    label="Size UOM"
                    label-for="input-size_uom"
                    label-cols="2"
                >
                    <b-form-input
                        type="text"
                        id="input-size_uom"
                        v-model="model.size_uom"
                        placeholder="Size Unit of Measure"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="is_task-group"
                    label="Is Task*"
                    label-for="input-is_task"
                    label-cols="2"
                >
                    <b-form-checkbox
                        id="input-is_task"
                        v-model="model.is_task"
                        name="input-is_task"
                        :value="true"
                        :unchecked-value="false"
                    >
                    </b-form-checkbox>
                </b-form-group>

                <b-form-group
                    id="is_order_item-group"
                    label="Is Order Item*"
                    label-for="input-is_order_item"
                    label-cols="2"
                >
                    <b-form-checkbox
                        id="input-is_order_item"
                        v-model="model.is_order_item"
                        name="input-is_order_item"
                        :value="true"
                        :unchecked-value="false"
                    >
                    </b-form-checkbox>
                </b-form-group>

                <!-- <b-form-group
                    id="is_asset-group"
                    label="Is Asset"
                    label-for="input-is_asset"
                    label-cols="2"
                >
                    <b-form-checkbox
                        id="input-is_asset"
                        v-model="model.is_asset"
                        name="input-is_asset"
                        :value="true"
                        :unchecked-value="false"
                    >
                    </b-form-checkbox>
                </b-form-group> -->

                <b-form-group
                    id="is_discount-group"
                    label="Is Discount"
                    label-for="input-is_discount"
                    label-cols="2"
                >
                    <b-form-checkbox
                        id="input-is_discount"
                        v-model="model.is_discount"
                        name="input-is_discount"
                        :value="true"
                        :unchecked-value="false"
                    >
                    </b-form-checkbox>
                </b-form-group>

                <b-button-group size="sm">
                    <b-button
                        variant="secondary"
                        :disabled="loading ? true : false"
                        @click="cancel()"
                        >Cancel</b-button
                    >
                    <b-button
                        type="submit"
                        v-if="hasPermissionUpdate"
                        variant="primary"
                        :disabled="loading ? true : false"
                        >{{ submitLabel }}</b-button
                    >
                    <b-button
                        v-if="this.model.id"
                        v-show="hasPermissionDelete"
                        @click="deleteItem()"
                        class="mr-2"
                        variant="warning"
                    >
                        Delete Item
                    </b-button>
                </b-button-group>
            </b-form>
        </b-card-body>
    </b-card>
</template>
<script>
import permissionsMixins from '@/mixins/permissionsMixins'

export default {
    name: 'ItemTypes-view',
    mixins: [permissionsMixins],
    data() {
        return {
            model: {
                id: 0,
                name: null,
                description: null,
                uom: null,
                size_uom: null,
                is_task: false,
                is_order_item: false,
                is_asset: false,
                is_discount: false,
            },
            loading: false,
            hasErrors: false,
        }
    },
    props: ['item'],
    computed: {
        title() {
            return this.model.id ? 'Edit Item Type' : 'New Item Type'
        },
        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Create'
            }
        },
    },
    watch: {},
    mounted() {
        if (this.item.id) this.model = { ...this.item }
        console.log('item', this.model)
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        onSubmit() {
            const model = { ...this.model }
            const path = model.id ? 'itemType/update' : 'itemType/create'
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            const message = model.id ? 'Updated' : 'Created'
                            this.$emit('success', message, model.name)
                        })
                        .catch(error => {
                            console.error('Item Type Submit Error', error)
                            this.$emit('error', error, model.name)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },

        deleteItem() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'itemType/delete'

            // Generate and display confirmation prompt
            const title = 'Delete Item Type?'
            const message = `Are you sure you want to delete ${model.name}?`
            const errorMsg = 'Unable to delete Item Type!'

            this.$emit(
                'delete-item',
                message,
                title,
                model.id,
                () => {
                    this.$emit('success', 'Deleted', model.name)
                },
                path,
                errorMsg
            )
        },
    },
}
</script>
<style></style>
